const methods = {
  add: null,
  addPullStream: null,
  addReadableStream: null,
  addFromStream: null,
  addFromFs: null,
  addFromURL: null,
  cat: null,
  catPullStream: null,
  catReadableStream: null,
  get: null,
  getPullStream: null,
  getReadableStream: null,
  ls: null,
  lsPullStream: null,
  lsReadableStream: null,
  'files.cp': null,
  'files.flush': null,
  'files.ls': null,
  'files.mkdir': null,
  'files.mv': null,
  'files.read': null,
  'files.readPullStream': null,
  'files.readReadableStream': null,
  'files.rm': null,
  'files.stat': null,
  'files.write': null,
  'block.get': null,
  'block.put': null,
  'block.stat': null,
  refs: null,
  refsReadableStream: null,
  refsPullStream: null,
  'refs.local': null,
  'refs.localReadableStream': null,
  'refs.localPullStream': null,
  'dag.get': null,
  'dag.put': null,
  'dag.tree': null,
  'object.data': null,
  'object.get': null,
  'object.links': null,
  'object.new': null,
  'object.patch.addLink': null,
  'object.patch.appendData': null,
  'object.patch.rmLink': null,
  'object.patch.setData': null,
  'object.put': null,
  'object.stat': null,
  'pin.add': null,
  'pin.ls': null,
  'pin.rm': null,
};

export default methods;
